(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["simple-blog-list"] && !Shopify.designMode) return;
  try {
    
  class SimpleBlogListTabs {
    constructor(root) {
      this.root = root;
      this.tabs = root.querySelectorAll('.simple-blog-list__tab');
      // root は `[data-tab-filter]` のタブ帯そのもので、記事の <ul> は**その兄弟**。
      // root 配下を探すと items が常に0件になり、タブを押しても絞り込みが起きない。
      // セクションまで遡ってから探す。
      const scope = root.closest('.simple-blog-list') || root.parentElement || root;
      this.items = scope.querySelectorAll('.simple-blog-list__item');
      this.tabs.forEach((tab) => tab.addEventListener('click', (e) => this.onTabClick(e)));
    }

    onTabClick(event) {
      const target = event.currentTarget;
      const filterTag = target.dataset.filterTag;
      this.tabs.forEach((t) => {
        const active = t === target;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.items.forEach((item) => {
        const tags = (item.dataset.articleTags || '').split(',').map((s) => s.trim());
        const match = filterTag === '__all__' || tags.includes(filterTag);
        if (match) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', '');
        }
      });
    }
  }

  document.querySelectorAll('[data-tab-filter]').forEach((el) => new SimpleBlogListTabs(el));

  } catch(e) { console.error(e); }
})();
})();
